module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slideshow"
  }, [_c('img', {
    ref: "slideshowImage1",
    class: {
      'fade-out': _vm.background1FadeOut
    },
    attrs: {
      "src": _vm.backgrounds[_vm.background1Index].url
    }
  }), _vm._v(" "), _c('img', {
    ref: "slideshowImage2",
    class: {
      'fade-out': !_vm.background1FadeOut
    },
    attrs: {
      "src": _vm.backgrounds[_vm.background2Index].url
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-cbaedb70!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Slideshow.vue
// module id = 100
// module chunks = 0